"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchCustomerUsersApi = exports.useCustomerUsers = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const models_1 = require("../../../models");
const useCustomerUsers = (subscriptionType, customerID) => {
    const fetchCustomerUsersApi = (0, exports.useFetchCustomerUsersApi)(customerID);
    return (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: ['customer-user'],
        queryFn: fetchCustomerUsersApi,
        enabled: subscriptionType === models_1.SubscriptionType.FORTIES && !!customerID,
    });
};
exports.useCustomerUsers = useCustomerUsers;
const useFetchCustomerUsersApi = (customerID) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return async () => {
        const url = `${config.SHIPPING_ENDPOINT?.replace('/api/v2/tms/', '')}/Customers/${customerID}/users`;
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
};
exports.useFetchCustomerUsersApi = useFetchCustomerUsersApi;
//# sourceMappingURL=useCustomer.js.map